import { useTranslation } from 'react-i18next';

import { formatInstantAsDay } from 'support/helpers/dateTime/dateTime';
import { Connectors, IntegrationDTO, RelationshipV2 } from 'support/types';
import { Section } from 'components/Display/Section/Section';
import { Translate } from 'components/Translate/Translate';

const CONNECTORS_WITH_SPECIAL_GUIDELINES: Array<Connectors> = [Connectors.WECLAPP, Connectors.XENTRAL_V3];
type ConnectionTestGuidelinesProps = {
  connector: Connectors | undefined;
  connectorConfig: IntegrationDTO['connectorConfig'];
  relationship: RelationshipV2;
};
export const ConnectionTestGuidelines = ({
  connector,
  connectorConfig,
  relationship,
}: ConnectionTestGuidelinesProps) => {
  const { t } = useTranslation();
  if (!connector) {
    return null;
  }
  const activeFromDate = relationship.active_from ? formatInstantAsDay(relationship.active_from) : undefined;
  const documentType = relationship.message_type;

  return (
    <div className="flex flex-col gap-2">
      <Section.Title>{t('connections:connectionTest.testGuidelinesSection.title')}</Section.Title>
      <Section.Subtitle>{t('connections:connectionTest.testGuidelinesSection.description')}</Section.Subtitle>
      <div className="space-y-4 rounded-lg bg-gray-50 p-6 text-sm text-gray-700">
        {CONNECTORS_WITH_SPECIAL_GUIDELINES.includes(connector) ? (
          <Translate
            i18nKey={`connections:connectionTest.testGuidelinesSection.guidelines.${connector.includes('XENTRAL') ? 'XENTRAL' : connector}.${documentType}`}
            values={{
              ...connectorConfig,
              documentType: t(`common:messageTypes.plural.${documentType}`).toLowerCase(),
              activeFromDate,
            }}
          />
        ) : (
          <Translate
            i18nKey={`connections:connectionTest.testGuidelinesSection.guidelines.other`}
            values={{
              ...connectorConfig,
              documentType: t(`common:messageTypes.plural.${documentType}`).toLowerCase(),
              activeFromDate,
            }}
          />
        )}
      </div>
    </div>
  );
};

/*
 * i18n
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.ORDER')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.ORDER_RESPONSE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.SHIPPING_NOTICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.INVOICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.CREDIT_NOTE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.DISPATCH_INSTRUCTION')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.DISPATCH_INSTRUCTION_RESPONSE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.RECEIVING_NOTICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.REMITTANCE_ADVICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.WECLAPP.PRODUCT_CATALOG')
 *
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.ORDER')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.ORDER_RESPONSE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.SHIPPING_NOTICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.INVOICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.CREDIT_NOTE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.DISPATCH_INSTRUCTION')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.DISPATCH_INSTRUCTION_RESPONSE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.RECEIVING_NOTICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.REMITTANCE_ADVICE')
 * t('connections:connectionTest.testGuidelinesSection.guidelines.XENTRAL.PRODUCT_CATALOG')
 *
 */
